import { MarketId, getPausedOperations } from '@velocity-exchange/common';
import { useMemo } from 'react';
import { useTargetPerpMarketAccount } from './useTargetMarketAccount';

const useIsMarketFundingPaused = (marketId: MarketId): boolean => {
	const perpMarketAccount = useTargetPerpMarketAccount(marketId);

	const isFundingPaused = useMemo(() => {
		if (!perpMarketAccount) return false;

		const pausedOperations = getPausedOperations(perpMarketAccount);

		return pausedOperations.includes('Funding');
	}, [perpMarketAccount]);

	return isFundingPaused;
};

export default useIsMarketFundingPaused;
